export type PageBox = { page: number; top: number; bottom: number };

/** The page a reader is on: the one crossing a line a third of the way down the view, or the last page once scrolled
 * to the very end, as a short last page may never reach that line. Pages are in order; null if there are none. */
export function pageInView(boxes: PageBox[], viewTop: number, viewHeight: number, atEnd: boolean): number | null {
  const last = boxes.at(-1);
  if (!last) return null;
  if (atEnd) return last.page;
  const line = viewTop + viewHeight / 3;
  return (boxes.find((b) => line < b.bottom) ?? last).page;
}
